import {NgModule} from '@angular/core';
import {PanelComponent} from './panel/panel.component';
import { PanelsComponent } from './panels.component';
import { PanelActionsComponent } from './panel/panel-actions/panel-actions.component';
import {ActionsModule} from '../actions/actions.module';
import { PanelContentComponent } from './panel/panel-content/panel-content.component';

@NgModule({
    declarations: [
        PanelComponent,
        PanelsComponent,
        PanelActionsComponent,
        PanelContentComponent
    ],
    imports: [
        ActionsModule
    ],
    exports: [
        PanelComponent,
        PanelsComponent,
        PanelActionsComponent,
        PanelContentComponent
    ]
})
export class PanelsModule {
}
